export enum BUTTON_VARIANT {
  TEXT = 'text',
  OUTLINED = 'outlined',
  CONTAINED = 'contained',
}

export enum BUTTON_TYPE {
  BUTTON = 'button',
  SUBMIT = 'submit',
  RESET = 'reset',
}

export enum BUTTON_COLOR {
  DEFAULT = 'default',
  INHERIT = 'inherit',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum BUTTON_SIZE {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export enum TEXT_FIELD_VARIANT {
  STANDARD = 'standard',
  FILLED = 'filled',
  OUTLINED = 'outlined',
}

export enum TEXT_FIELD_COLOR {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum TEXT_FIELD_TYPE {
  TEXT = 'text',
  NUMBER = 'number',
}

export enum SWITCH_COLOR {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum RADIO_COLOR {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum DIALOG_SIZE {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}
